import Axios from "axios";
import AppConfig from "@/config/AppConfig";

export default {
  pending(any, apsId) {
    const params = {
      apsId: apsId,
      any: any
    }
    return Axios.get(
      "/bonusCategory/pending", {
        params: params
      }
    );
  },
  pendingPdf(apsUserName, apsId, agencyName) {
    const params = {
      apsUserName: apsUserName,
      apsId: apsId,
      agencyName: agencyName
    }
    return Axios.get(
      "/bonusCategory/pendingPdf", {
        responseType: 'arraybuffer',
        params: params
      }
    );
  },
  pendingExcel(apsUserName, apsId, agencyName) {
    const params = {
      apsUserName: apsUserName,
      apsId: apsId,
      agencyName: agencyName
    }
    return Axios.get(
      "/bonusCategory/pendingExcel", {
        responseType: 'arraybuffer',
        params: params
      }
    );
  },
  preliquidationGeneration(data,apsRuc, apsId, agencyName) {
    const params = {
      agencyName: agencyName,
      apsId: apsId,
      apsRuc: apsRuc,
    }
    return Axios.post(
      "/bonusCategory/preliquidationGeneration",
      data, {
        params: params
      }
    );
  },
  validatePermission(apsRuc) {
    const params = {
      apsRuc: apsRuc,
    }
    return Axios.get(
      "/bonusCategory/validatePermission", {
        params: params
      }
    );
  },
  preliquidationApprove(data, apsId, agencyName) {
    const params = {
      agencyName: agencyName,
      apsId: apsId,
    }
    return Axios.post(
      "/bonusCategory/preliquidationApprove", {
        preliquidationsId: data
      }, {
        params: params
      }
    );
  },
  preliquidationApproveAndBill(data, apsId, agencyName) {
    const params = {
      agencyName: agencyName,
      apsId: apsId
    }
    return Axios.post(
      "/bonusCategory/preliquidationApproveAndBill", {
        preliquidationsId: data
      }, {
        params: params
      }
    );
  },
  preliquidationReject(data, apsId, agencyName) {
    const params = {
      agencyName: agencyName,
      apsId: apsId,
    }
    return Axios.post(
      "/bonusCategory/preliquidationReject", {
        preliquidationsId: data
      }, {
        params: params
      }
    );
  },
  preliquidation(any, apsId,agencyName) {
    const params = {
      apsId: apsId,
      agencyName: agencyName,
      any: any
    }
    return Axios.get(
      "/bonusCategory/preliquidation", {
        params: params
      }
    );
  },
  liquidation(any, apsId) {
    const params = {
      apsId: apsId,
      any: any
    }
    return Axios.get(
      "/bonusCategory/liquidation", {
        params: params
      }
    );
  },
  bonusCategoryPdf(id) {
    const params = {
      id: id
    }
    return Axios.get(
      "/bonusCategory/bonusCategoryPdf", {
        responseType: 'arraybuffer',
        params: params
      }
    );
  },
  bonusCategoryPreliminarPdf(id) {
    const params = {
      id: id
    }
    return Axios.get(
      "/bonusCategory/bonusCategoryPreliminarPdf", {
        responseType: 'arraybuffer',
        params: params
      }
    );
  },
  bonusCategoryExcel(id) {
    const params = {
      id: id
    }
    return Axios.get(
      "/bonusCategory/bonusCategoryExcel", {
        responseType: 'arraybuffer',
        params: params
      }
    );
  },
  IsUserAgent(userId) {
    return Axios.get(AppConfig.siaerpBaseUrl + `Siaerp/GetAgenteById?idUsuario=${userId}`);
  },
  bonusDetailLiquidation(data)
  {
    const params = {
      nummero: nummero

    }
    return Axios.get(
      "/bonusCategory/bonusCategoryDetail",{
        params: params
      }
    );
  }
};